import {
  IconAnalytics,
  IconAtom,
  IconBell,
  IconBellGray,
  IconBinocularsGray,
  IconChainLink,
  IconChainLinkGray,
  IconChartBar,
  IconChartBarGray,
  IconChartRadius,
  IconChartRadiusGray,
  IconClockGray,
  IconCloudCheckGray,
  IconCoil,
  IconDashboard,
  IconLayers,
  IconLocation,
  IconPenSquare,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSecurity,
  IconTagGray,
  IconTvocGray,
  IconUserCheck,
  IconWarning,
  IconWarningGray,
  IconZoneGray,
} from '@assets/images/icon';
import { IconTemp } from '@assets/images/main';
import { rtlsSystem } from '@assets/images/solution';
import video from '@src/assets/images/solution/manufacturingProcess/video/rtlsVideo.mp4';

import image1 from '@src/assets/images/solution/manufacturingAsset/img/1.avif';
import image2 from '@src/assets/images/solution/manufacturingAsset/img/2.avif';
import image3 from '@src/assets/images/solution/manufacturingAsset/img/3.avif';
import image4 from '@src/assets/images/solution/manufacturingAsset/img/4.avif';
import image5 from '@src/assets/images/solution/manufacturingAsset/img/5.avif';
import image6 from '@src/assets/images/solution/manufacturingAsset/img/6.avif';
import image7 from '@src/assets/images/solution/manufacturingAsset/img/7.avif';
import image8 from '@src/assets/images/solution/manufacturingAsset/img/8.avif';

export default {
  type: '製造ソリューション',
  banner: {
    title: '大規模物流倉庫の在庫資産をAIで効率的かつ正確に管理',
    desc: 'AI映像認識技術を活用し、鋼材コイルをはじめとする様々な物流資産を自動で把握し、正確かつ効率的に在庫を管理します。',
  },

  video: {
    title: '複雑な物流環境でもAIでリアルタイムに在庫資産を管理',
    desc: '従来の手動カウント方式では複雑な物流環境での効率が低く、ミスが頻発していました。ORBROのAIシステムは鋼材コイルなどの多様な物流資産を自動で識別し、正確に管理することで倉庫運営の効率性を高めます。',
    // play: video,
    image: image1,
  },

  func: [
    {
      theme: 'AI映像分析技術で様々な物流資産を正確に管理',
      title: 'AI映像ベースの資産自動カウント',
      desc: '鋼材コイルなど多様な物流資産をAIカメラがリアルタイムに正確に認識し、自動で在庫をカウントします。複雑な倉庫環境でも迅速かつ正確な在庫管理が可能です。',
      sub1: 'リアルタイム状況把握',
      icon1: IconClockGray,
      sub2: '統計データ提供',
      icon2: IconChartBarGray,
      image: image2,
    },
    {
      title: '鋼材コイルとパレットのAI認識と管理',
      desc: '鋼材コイルと運搬用パレットをAI映像技術で正確に同時認識し、複合資産の在庫管理を可能にします。形状が異なる資産が混在する状況でも効率的に在庫状況を管理できます。',
      sub1: 'リアルタイム位置追跡',
      icon1: IconBinocularsGray,
      sub2: '高精度提供',
      icon2: IconRulerGray,
      image: image3,
    },
    {
      title: '多様な資産モデル学習と自動管理システム',
      desc: 'AIが鋼材コイルやパレットを含む多様な資産モデルを学習し、認識することで、複合的な資産を正確に管理できます。',
      sub1: 'リスク資産指定',
      icon1: IconWarningGray,
      sub2: '対応方法設定',
      icon2: IconChartRadiusGray,
      image: image4,
    },
    {
      theme: '自動化されたデータ分析で物流運営の効率を最大化',
      title: 'エリア別在庫状況のリアルタイム把握',
      desc: '倉庫内の各エリアの在庫状況を即座に確認でき、データに基づいた正確な運営と迅速な意思決定をサポートします。',
      sub1: 'クラウドにデータ保存',
      icon1: IconClockGray,
      sub2: '統計データ提供',
      icon2: IconChartBarGray,
      image: image5,
    },
    {
      title: '時間帯別在庫物流量の変化追跡と予測',
      desc: '在庫物流量の時間帯ごとの変化を自動で記録・分析し、物流の流れを正確に予測し、効果的に対応できます。',
      sub1: 'リスク資産指定',
      icon1: IconWarningGray,
      sub2: '対応方法設定',
      icon2: IconChartRadiusGray,
      image: image6,
    },
    {
      title: '手動在庫管理の自動化',
      desc: 'AIによる自動カウントで従来の手動在庫管理を自動化し、人的ミスと時間コストを大幅に削減します。',
      sub1: 'クラウドにデータ保存',
      icon1: IconClockGray,
      sub2: '統計データ提供',
      icon2: IconChartBarGray,
      image: image7,
    },
    {
      title: '分析データをCSVファイルで出力',
      desc: '分析した在庫および物流データをCSVファイル形式で簡単に出力でき、各種レポートや分析に活用できます。',
      sub1: 'クラウドにデータ保存',
      icon1: IconClockGray,
      sub2: '統計データ提供',
      icon2: IconChartBarGray,
      image: image8,
    },
  ],

  system: {
    title: 'システム構成',
    img: rtlsSystem,
  },

  productTitle: '製品構成',
  product: [
    {
      tag: 'assetPackage',
    },
    {
      tag: 'workerPackage',
    },
  ],

  subfunc: {
    title: '主な機能概要',
    desc: '',

    data: [
      {
        icon: IconAtom,
        title: 'AIベースの資産自動認識',
        desc: 'AI技術で資産をリアルタイムに自動認識し、正確かつ効率的に管理します。',
      },
      {
        icon: IconCoil,
        title: '鋼材コイルとパレット認識',
        desc: '鋼材コイルとパレットをAIで同時認識し、複雑な環境でも正確に在庫管理します。',
      },
      {
        icon: IconLocation,
        title: '資産位置と状態モニタリング',
        desc: '倉庫内の資産位置と状態をリアルタイムで分析し、効率的に管理します。',
      },
      {
        icon: IconPenSquare,
        title: '手動在庫管理の自動化',
        desc: '従来の手動在庫管理を自動化し、業務効率と正確性を大幅に向上させます。',
      },
      {
        icon: IconDashboard,
        title: 'リアルタイム在庫状況ダッシュボード',
        desc: '倉庫内の資産状況を一目で把握できるリアルタイムダッシュボードを提供します。',
      },
      {
        icon: IconRoute,
        title: '資産移動経路分析',
        desc: 'AIで資産の移動経路と使用パターンを分析し、効率的な運用計画を支援します。',
      },
      {
        icon: IconLayers,
        title: 'エリア別在庫リアルタイム管理',
        desc: '各エリアの資産保有状況をリアルタイムで確認し、正確かつ効率的に管理します。',
      },
      {
        icon: IconChartBar,
        title: '時間帯別在庫変動分析',
        desc: '時間帯ごとの在庫変化を分析し、物流の流れを予測し迅速に対応します。',
      },
      {
        icon: IconSecurity,
        title: 'AIの高い認識精度',
        desc: 'AIが多様な資産を99%以上の精度で認識し、信頼性の高いデータを提供します。',
      },
      {
        icon: IconAnalytics,
        title: '運用データに基づく意思決定支援',
        desc: '分析された運用データを基に迅速かつ正確な意思決定と戦略立案を支援します。',
      },
    ],
  },

  contents: [
    {
      data: 'manufacturingAsset',
    },
    {
      data: 'logisticsAsset',
    },
    {
      data: 'blogMedical',
    },
    {
      data: 'blogRTLS',
    },
  ],
};
